import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';

const SectionKeyInfo = props => {
  const { publicData } = props;
  const trainingDuration = publicData?.trainingDuration;
  const dailyDuration = publicData?.dailyDuration;
  const maxParticipants = publicData?.maxParticipants;

  const hasKeyInfo = trainingDuration || dailyDuration || maxParticipants;

  if (!hasKeyInfo) {
    return null;
  }

  return (
    <div className={css.sectionKeyInfo}>
      <div className={css.keyInfoGrid}>

        <div className={css.keyInfoItem}>
          <div className={css.keyInfoIconWrapper}>
            <IconCard brand='clockLine' />
            <span className={css.keyInfoLabel}>
              <FormattedMessage
                id="ListingPage.keyInfoDuration"
                defaultMessage="Training Duration"
              />
            </span>
          </div>

          <span className={css.keyInfoValue}>
            {trainingDuration ? (
              <FormattedMessage
                id="ListingPage.keyInfoDurationDays"
                defaultMessage="{duration} days"
                values={{ duration: trainingDuration }}
              />
            ) : (
              '-'
            )}
          </span>
        </div>

        {/* <div className={css.keyInfoItem}>
          <div className={css.keyInfoIconWrapper}>
            <IconCard brand='clockLine' />
            <span className={css.keyInfoLabel}>
              <FormattedMessage
                id="ListingPage.keyInfoDailyDuration"
                defaultMessage="Daily Duration"
              />
            </span>
            <span className={css.keyInfoValue}>{dailyDuration || '-'}</span>
          </div>
        </div> */}

        <div className={css.keyInfoItem}>
          <div className={css.keyInfoIconWrapper}>
            <IconCard brand='users' />
            <span className={css.keyInfoLabel}>
              <FormattedMessage
                id="ListingPage.keyInfoParticipants"
                defaultMessage="Max Participants"
              />
            </span>
          </div>
          <span className={css.keyInfoValue}>{maxParticipants || '-'}</span>
        </div>
      </div>
    </div>
  );
};

export default SectionKeyInfo;
